import { fromJS, List } from 'immutable';
import {
  getIn,
  imJsUnion,
  setFirstInList,
  setLastInList,
} from '@client/shared/utils/immutableUtils/immutableUtils';
import { LOADING } from '@client/definitions/constants';

export const FUNDRAISER_REDUCER_KEY = 'fundraiserReducer';

export const PUT_AND_HANDLE_FUNDRAISER = 'PUT_AND_HANDLE_FUNDRAISER';
export const PUT_AND_HANDLE_FUNDRAISER_DATES =
  'PUT_AND_HANDLE_FUNDRAISER_DATES';
export const LOAD_FUNDRAISERS = 'LOAD_FUNDRAISERS';
export const LOAD_FUNDRAISER = 'LOAD_FUNDRAISER';
export const SET_FUNDRAISER_ERROR = 'SET_FUNDRAISER_ERROR';
export const SET_FUNDRAISER_STATUS = 'SET_FUNDRAISER_STATUS';
export const LOAD_FUNDRAISER_TYPE_DATA = 'LOAD_FUNDRAISER_TYPE_DATA';

export const LOAD_MORE_FUNDRAISER_COMMENTS = 'LOAD_MORE_FUNDRAISER_COMMENTS';
export const LOAD_FUNDRAISER_COMMENT = 'LOAD_FUNDRAISER_COMMENT';
export const POST_AND_HANDLE_FUNDRAISER_COMMENT =
  'POST_AND_HANDLE_FUNDRAISER_COMMENT';
export const DELETE_FUNDRAISER_COMMENT = 'DELETE_FUNDRAISER_COMMENT';
export const REPORT_FUNDRAISER_COMMENT = 'REPORT_FUNDRAISER_COMMENT';

/* DEFAULT FUNDRAISER STATE */
let defaultState = fromJS({
  fundraiser: {
    results: null,
  },
  fundraiserComment: {
    results: [],
  },
  fundraiserTypes: [],
  errors: {
    loadFundraisers: null,
  },
  status: null,
});

/* REDUCER */
export default function (state = defaultState, action = {}) {
  switch (action.type) {
    case LOAD_FUNDRAISERS: {
      const errors = state.get('errors');
      return state.merge({
        fundraiser: fromJS(action.payload),
        errors: errors.set('loadFundraisers', null),
      });
    }
    case LOAD_FUNDRAISER: {
      const fundraiserPayload = fromJS(action.payload);
      const fundraisers = state.getIn(['fundraiser', 'results']) || List();
      const updatedList = setLastInList(fundraisers, 'id', fundraiserPayload);

      return state.setIn(['fundraiser', 'results'], updatedList);
    }
    case LOAD_FUNDRAISER_COMMENT: {
      return state.setIn(['fundraiserComment'], fromJS(action.payload));
    }
    case LOAD_MORE_FUNDRAISER_COMMENTS: {
      const newFundraiserComment = fromJS(action.payload);

      const currentComments = getIn(state, 'fundraiserComment', 'results');
      const moreComments = getIn(newFundraiserComment, 'results');
      const updatedComments = imJsUnion(currentComments, moreComments);

      const updatedFundraiserComment = newFundraiserComment.set(
        'results',
        updatedComments
      );

      return state.set('fundraiserComment', updatedFundraiserComment);
    }
    case PUT_AND_HANDLE_FUNDRAISER: {
      const fundraiserIdToUpdate = action.payload.id;
      const updatedFundraiser = fromJS(action.payload);

      const fundraiserList = getIn(state, 'fundraiser', 'results');
      const indexToUpdate = fundraiserList.findIndex((fundraiser) => {
        return getIn(fundraiser, 'id') === fundraiserIdToUpdate;
      });

      return state.setIn(
        ['fundraiser', 'results', indexToUpdate],
        updatedFundraiser
      );
    }
    case PUT_AND_HANDLE_FUNDRAISER_DATES: {
      const fundraiserIdToUpdate = action.payload.id;
      const updatedFundraiser = fromJS(action.payload);

      const fundraiserList = getIn(state, 'fundraiser', 'results');
      const indexToUpdate = fundraiserList.findIndex((fundraiser) => {
        return getIn(fundraiser, 'id') === fundraiserIdToUpdate;
      });

      return state.setIn(
        ['fundraiser', 'results', indexToUpdate],
        updatedFundraiser
      );
    }
    case POST_AND_HANDLE_FUNDRAISER_COMMENT: {
      const comments = getIn(state, 'fundraiserComment', 'results');
      const updatedComments = setFirstInList(
        comments,
        'id',
        fromJS(action.payload.data)
      );
      return state.setIn(['fundraiserComment', 'results'], updatedComments);
    }
    case DELETE_FUNDRAISER_COMMENT: {
      const error = state.get('errors');
      const allComments = getIn(state, 'fundraiserComment', 'results');

      const filteredComments = allComments.filter((comment) => {
        return getIn(comment, 'id') !== action.payload;
      });
      return state.setIn(['fundraiserComment', 'results'], filteredComments);
    }
    case LOAD_FUNDRAISER_TYPE_DATA: {
      return state.merge({
        fundraiserTypes: fromJS(_cleanFundraiserTypes(action.payload)),
      });
    }
    case SET_FUNDRAISER_ERROR: {
      return state.setIn(['errors', 'default'], action.payload);
    }
    case SET_FUNDRAISER_STATUS: {
      return state.setIn(['status'], action.payload);
    }
    default:
      return state;
  }
}

function _cleanFundraiserTypes(fundraiserTypes) {
  const cleanFundraiserTypes = fundraiserTypes.map((type) => {
    return type.fields;
  });

  return cleanFundraiserTypes.sort((a, b) => a.id - b.id);
}
